import React, { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import styles from "../../../styles/style";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineMessage,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addToCart } from "../../../redux/actions/cartAction";
import { useDispatch } from "react-redux";
import {
  addToWishlistAsync,
  removeFromWishlistAsync,
} from "../../../redux/actions/wishlistAction";
import { Link } from "react-router-dom";

const ProductCardDetails = ({ data, setOpen }) => {
  const { cart } = useSelector((state) => state.cart);
  const { wishlist } = useSelector((state) => state.wishlist);
  const [count, setCount] = useState(1);
  const [click, setClick] = useState(false);
  const [select, setSelect] = useState(false);

  const dispatch = useDispatch();

  const handleMessageSubmit = () => {};

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const addToCartHandler = (id) => {
    const isItemExists = cart.find((i) => (i._id || i.id) === id);
    if (isItemExists) {
      toast.error("Item already in cart!");
    } else {
      if (data?.stock < count) {
        toast.error("Product stock limited!");
      } else {
        const cartData = { ...data, qty: count, _id: data?._id || data?.id };
        dispatch(addToCart(cartData));
        toast.success("Item added to cart successfully!");
      }
    }
  };

  useEffect(() => {
    if (!data) return;
    if (wishlist.find((i) => (i._id || i.id) === (data?._id || data?.id))) {
      setClick(true);
    } else {
      setClick(false);
    }
  }, [wishlist, data]);

  const toggleWishlistHandler = () => {
    const id = data?._id || data?.id;
    const exists = wishlist && wishlist.find((i) => (i._id || i.id) === id);
    if (exists) {
      dispatch(removeFromWishlistAsync(id));
      setClick(false);
    } else {
      dispatch(addToWishlistAsync(data));
      setClick(true);
    }
  };

  return (
    <div className="bg-[#fff]">
      {data && (
        <div className="fixed w-full h-screen top-0 left-0 bg-[#00000030] z-40 flex items-center justify-center">
          <div className="w-[90%] 800px:w-[60%] h-[90vh] overflow-scroll 800px:h-[75vh] bg-white rounded-md shadow-sm relative p-4">
            <RxCross1
              size={30}
              className={"absolute right-3 top-3 z-50"}
              onClick={() => setOpen(false)}
            />
            <div className="block w-full 800px:flex">
              <div className="w-full 800px:w-[50%] p-3">
                <img src={data?.images?.[0]?.url || data?.imageUrl[0]?.url || null} alt="" />
                <div className="flex">
                  <Link
                    to={`/shop/preview/${data.shop._id}`}
                    className="flex items-center"
                  >
                    <img
                      src={data?.images?.[0]?.url || data?.imageUrl[0]?.url || null}
                      alt={data.name}
                      className="w-[50px] h-[50px] rounded-full mr-2"
                    />
                    <div className="">
                      <h3 className={`${styles.shop_name}`}>
                        {data?.shop.name}
                      </h3>
                      <h5 className="pb-3 text-[15px] ">
                        ({data?.shop.ratings}) Ratings
                      </h5>
                    </div>
                  </Link>
                </div>
                <div
                  className={`${styles.button} bg-[#000] mt-4 rounded-[4px] h-11`}
                  onClick={handleMessageSubmit}
                >
                  <span className="text-[#fff] flex items-center">
                    Send Message <AiOutlineMessage className="ml-1" />
                  </span>
                </div>
                <h5 className="text-[16px] text-[red] mt-5">
                  ({data?.soldOut || 0}) Sold Out
                </h5>
              </div>
              <div className="w-full 800px:w-[50%] pt-5 pl-[5px] pr-[5px]">
                <h1 className={`${styles.productTitle} text-[20px]`}>
                  {data?.name}
                </h1>
                <p className="mt-2 mx-2">{data?.description}</p>
                <div className="flex pt-3">
                  <h4 className={`${styles.productDiscountPrice}`}>
                    {data?.discountPrice}$
                  </h4>
                  <h3 className={`${styles.price}`}>
                    {data?.originalPrice ? data?.originalPrice + "$" : null}
                  </h3>
                </div>
                <div className="flex items-center mt-12 justify-between pr-3 ">
                  <div>
                    <button
                      className="bg-gradient-to-r from-teal-400 to-teal-500 text-white font-bold rounded-l px-4 py-2 shadow-lg hover:opacity-75 transition duration-300 ease-in-out"
                      onClick={incrementCount}
                    >
                      +
                    </button>
                    <span className="bg-gray-200 text-gray-800 font-medium px-4 py-[11px]">
                      {count}
                    </span>
                    <button
                      className="bg-gradient-to-r from-teal-400 to-teal-500 text-white font-bold rounded-l px-4 py-2 shadow-lg hover:opacity-75 transition duration-300 ease-in-out"
                      onClick={decrementCount}
                    >
                      -
                    </button>
                  </div>
                  <div>
                    {click ? (
                      <AiFillHeart
                        size={30}
                        className="cursor-pointer"
                        onClick={toggleWishlistHandler}
                        color={"red"}
                        title="Remove from Wishlist"
                      />
                    ) : (
                      <AiOutlineHeart
                        size={30}
                        className="cursor-pointer"
                        onClick={toggleWishlistHandler}
                        color={"#333"}
                        title="Add to Wishlist"
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`${styles.button} mt-6 rounded-[4px] h-11 flex items-center`}
                  onClick={() => addToCartHandler(data._id)}
                >
                  <span className="text-[#fff] flex items-center">
                    Add to Cart <AiOutlineShoppingCart className="ml-1" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCardDetails;
